// AWS Amplify Configuration
// Values are loaded from environment variables (.env file)

const awsConfig = {
  // AWS Region
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  
  // Cognito User Pool (Authentication)
  userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
  userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
  
  // Optional: Identity Pool for AWS resource access
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || '',
  
  // API Gateway endpoint
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT || '',
  
  // S3 Bucket for file storage
  s3Bucket: process.env.REACT_APP_S3_BUCKET || '',
  s3Region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
};

export default awsConfig;

